module.exports = __webpack_public_path__ + "img/logo.d95ba8e2.png";